import {registerOutboxExecutor} from 'src/offline/executorRegistry';
import {registerFileUploadExecutor} from 'src/offline/pendingUploads';
import type {FormsOfflineApi} from './offline/api';
import {bindFormsOfflineApi} from './offline/api';
import {createFormExecutor} from './offline/executors';
import {startFormsCacheScheduler} from './offline/formsCacheScheduler';
import {FORM_OUTBOX_KINDS} from './offline/localFiles';

// Called from the offline composition root, which owns the API client — this
// tier may not import it. Registers the outbox executors and the cache refresher.
export const registerFormsOffline = (api: FormsOfflineApi): void => {
  bindFormsOfflineApi(api);
  registerFileUploadExecutor();
  registerOutboxExecutor(FORM_OUTBOX_KINDS.create, createFormExecutor);
  startFormsCacheScheduler();
};
